import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', function() {
    // Workers Testimonial Slider Initialization
    const workersTestimonialSlider = new Swiper('.workers-testimonial-slider', {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: false,
        loop: true,
        speed: 800,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        effect: 'slide',
        breakpoints: {
            640: {
                slidesPerView: 1.2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            }
        },
        on: {
            init: function() {
                animateWorkersTestimonials();
            },
            slideChangeTransitionStart: function() {
                animateWorkersTestimonials();
            }
        }
    });
    
    // Function to add animation to testimonials
    function animateWorkersTestimonials() {
        const activeSlides = document.querySelectorAll('.workers-testimonial-slider .swiper-slide-active, .workers-testimonial-slider .swiper-slide-visible');
        
        activeSlides.forEach((slide, index) => {
            const card = slide.querySelector('.rounded-xl');
            if (card) {
                // Add slight delay for each card to create cascading effect
                setTimeout(() => {
                    // Add subtle animation
                    card.style.transform = 'translateY(0)';
                    card.style.transition = 'all 0.6s ease-out';
                    
                    // Add enhanced hover effect
                    card.addEventListener('mouseenter', () => {
                        card.style.transform = 'translateY(-8px)';
                        card.style.boxShadow = '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)';
                    });
                    
                    card.addEventListener('mouseleave', () => {
                        card.style.transform = 'translateY(0)';
                        card.style.boxShadow = '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)';
                    });
                }, index * 150);
            }
        });
    }
    
    // Handle resize events to ensure proper layout
    window.addEventListener('resize', function() {
        const workersTestimonialSlider = document.querySelector('.workers-testimonial-slider');
        if (workersTestimonialSlider && workersTestimonialSlider.swiper) {
            workersTestimonialSlider.swiper.update();
            animateWorkersTestimonials();
        }
    });
});